import React, { useState } from "react";
import { Segmented } from "antd";
import TrainingCoursesTable from "./TrainingCoursesTable";
import EmployeeProgressTable from "./EmployeeProgressTable";
import HeaderComponent from "components/card/HeaderComponent";

export default function TrainingProgramTabs() {
  const [activeTab, setActiveTab] = useState("Training Courses");

  return (
    <div>

      <Segmented
        options={["Training Courses", "Employee Programs"]}
        value={activeTab}
        onChange={setActiveTab}
        className="bg-gray-100 p-1"
        shape="round"
      />

      <div className="mt-6">
        {activeTab === "Training Courses" && (
          <div>
            <HeaderComponent
              title="Available Training Courses"
              description="Overview of all training programs and their enrollment statistics"
              bgcolor=""
	          >
              <TrainingCoursesTable/>
            </HeaderComponent>
          </div>

        )}
        {activeTab === "Employee Programs" && (
          <div>
            <HeaderComponent
              title="Employee Training Progress"
              description="Individual employee training statistics and achievements"
              bgcolor=""
            >
              <EmployeeProgressTable/>
            </HeaderComponent>
          </div>
        )}
      </div>
    </div>
  );
}
